let language = {
    STORE_PRODUCT_FILTER_STORE_STATUS_CLOSE: "不活跃",
    STORE_PRODUCT_FILTER_STORE_STATUS_ACTIVE: "活跃",
    STORE_PRODUCT_FILTER_STORE_STATUS_DRAFT: "草稿",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECTING: "连接中",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECTING_DES: "您的商店正在连接中，如果长时间没有响应，请刷新此页面",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECTED: "已连接",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECTED_DES: "连接成功",
    STORE_PRODUCT_FILTER_STORE_STATUS_UNEXPECTED_ERROR: "未知错误",
    STORE_PRODUCT_FILTER_STORE_STATUS_UNEXPECTED_ERROR_DES1: "连接到您的商店时发生未知错误。请检查以下内容：确保您的网站地址正确并可在互联网上访问。允许",
    STORE_PRODUCT_FILTER_STORE_STATUS_UNEXPECTED_ERROR_DES2: "访问您的电子商店的读写权限。",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECT_FAILED: "连接失败",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECT_FAILED_DES: "您可以点击此标签尝试重新连接",
    STORE_PRODUCT_FILTER_STORE_STATUS_AUTH_FAILED: "授权失败",
    STORE_PRODUCT_FILTER_STORE_STATUS_AUTH_FAILED_DES: "请到右侧的“操作”中的“设置”重新授权",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_URL: "无效的URL",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_URL_DES: "请到右侧的“操作”中的“设置”重新填写您的URL",
    STORE_PRODUCT_FILTER_STORE_STATUS_MISSING_AUTH: "缺少授权",
    STORE_PRODUCT_FILTER_STORE_STATUS_MISSING_AUTH_DES: "请到右侧的“操作”中的“设置”重新授权",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_SHOP: "无效的商店",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_SHOP_DES: "请确保您已成功注册一个商店。",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_PLUGIN: "无效的插件",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_PLUGIN_DES: "请确保您已在Shopify中安装我们的插件"
};

export { language }
